import {log, delay, nextFrame} from './utils.js';
import { destroySwipersIn, initSwipersIn } from './hulk.js';

const $ = window.jQuery;

const modalEl = document.getElementById('fenix');

const $modal = $('#fenix');
let modalInstance = null;
let fenixIsOpen = false;
let fenixModalPurpose = null;

const $header = $modal.find('#fenixHeader');
const $title = $modal.find('#fenixTitle');
const $body = $modal.find('#fenixBody');
const $footer = $modal.find('#fenixFooter');
let startY = 0, endY = 0, dragging = false;

let allowHide = false; // gate to avoid infinite loop when we re-call hide()

let hasBackdrop = true;
let handlersInitialized = false;

export function getFenixModalPurpose() {
    return fenixModalPurpose;
}
export function setFenixModalPurpose(purpose) {
    fenixModalPurpose = purpose;
}

export function getFenixModalIsOpen() {
    return fenixIsOpen;
}

export function getFenixModalElement() {
    return modalEl;
}

export function initFenixModal(backdrop=true) {
    if(!$modal.length) {
        log('Fenix Modal not found');
        return false;
    }

    log('Initializing Fenix Modal');

    // Normalize local variable and set the global backdrop state
    if(backdrop == true) {
        hasBackdrop = true;
    } else {
        backdrop = false;
        hasBackdrop = false;
    }

    try {
        const options = {
            backdrop: backdrop,
            scroll: true // Don't lock scroll when the modal is open, for performance reasons.
        };
        modalInstance = bootstrap.Offcanvas.getOrCreateInstance($modal[0], options);
        if(!modalInstance) {
            log('Fenix Modal not found');
            return false;
        }
    } catch(error) {
        log('Error initializing Fenix Modal', error);
        return false;
    }

    if(handlersInitialized === false) {

        // Header-only touch events
        $header.on('touchstart', function (e) {
            if (!isMobile()) return;

            // Don't start drag if touch begins on close button or other interactive controls
            var startEl = e.target;
            if (startEl.closest('.btn-close,[data-bs-dismiss="offcanvas"],button,a,input,textarea,select,label')) {
                return; // let the control handle the tap/click
            }
            
            var t = e.originalEvent.touches && e.originalEvent.touches[0];
            if (!t) return;
            startY = t.clientY;
            endY = startY;
            dragging = true;
            // stop the page behind from scrolling immediately
            e.stopPropagation();
        });

        $header.on('touchmove', function (e) {
            if (!dragging) return;
            var t = e.originalEvent.touches && e.originalEvent.touches[0];
            if (!t) return;
            endY = t.clientY;

            // Optional minimal visual feedback: move dialog with finger (inline style wins over CSS)
            // var delta = endY - startY;
            // give slight resistance when dragging upward to feel native
            // var translate = delta > 0 ? delta : delta * 0.15;
            // $dialog.css('transform', 'translateY(' + translate + 'px)');

            e.preventDefault(); // prevents page scroll during drag
            e.stopPropagation();
        });

        $header.on('touchend touchcancel', function (e) {
            if (!dragging) return;
            dragging = false;

            // grab final position from changedTouches if available
            var ct = e.originalEvent.changedTouches && e.originalEvent.changedTouches[0];
            if (ct) endY = ct.clientY;

            var delta = endY - startY;          // >0 = down, <0 = up
            var dirDown = delta > 0 && Math.abs(delta) > 20; // small deadzone
            var pct = percentFromBottom(endY);

            // clear visual drag transform and snap
            // $dialog.css('transform', ''); //part of visual feedback
            snapToBand(pct, dirDown);
        });

        // Animate the closing motion when using a close button as well as the drag down.
        modalEl.addEventListener('hide.bs.offcanvas', function (e) {
            log('Fenix Modal hide event');

            // If purpose is writeReviewModal, move the form content to the body for storage before it's closed.
            if(getFenixModalPurpose() === 'writeReviewModal') {
                const $writeReviewFormContent = $body.find('#writeReviewFormContent');
                $writeReviewFormContent.appendTo('#writeReviewFormContainer');
            }

            // Clear content before closing. 66% Faster on mobile, 33% Faster on desktop @ 6x throttled!
            setFenixModalContent(true, null, true, true, true, true);
            
            // Only animate on mobile
            if (!window.matchMedia('(max-width: 768px)').matches) return;

            // If a drag-close already set .closing (your swipe code), allow default hide
            if (modalEl?.classList?.contains('closing') || allowHide) {
                allowHide = false; // reset for next time
                return;
            }

            // Intercept default hide to run our animation
            // e.preventDefault();
            modalEl?.classList?.add('closing');

            allowHide = true;
            modalInstance.hide();
            fenixIsOpen = false;
            fenixModalPurpose = null;
        });

        modalEl.addEventListener('hidden.bs.offcanvas', function () {
            console.log('Fenix Modal hidden');
            modalEl?.classList?.remove('closing');
            
            // reset the modal-content height to default for next time
            $modal.removeClass('tall');
            $modal.removeClass('short');

            // Clear content
            // Disable for testing.
            // setFenixModalContent(null);
        });

        handlersInitialized = true;
    }
}

export async function destroyFenixModal() {
    // Make sure the modal is closed before destroying it.
    if ($modal.hasClass('show')) {
        const hidePromise = new Promise(resolve => {
            modalEl.addEventListener('hidden.bs.offcanvas', resolve, { once: true });
        });
        modalInstance.hide();
        fenixIsOpen = false;
        fenixModalPurpose = null;
        await hidePromise; //wait for the modal to close before destroying it.
        await delay(0); // Microtask to ensure the modal is closed before destroying it. Otherwise it causes console error: the modal is disposed before the 'hiding' class is removed.
    }
    // Dispose the modal instance.
    if(modalInstance) {
        modalInstance.dispose();
    }
}

export function getFenixModalBackdropState() {
    return hasBackdrop;
}

function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
}

function setSheet(size) {
    // default = 80% (no class)
    $modal.removeClass('short tall');
    if (size === 'short') $modal.addClass('short');
    if (size === 'tall')  $modal.addClass('tall');
}

function percentFromBottom(y) {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return (1 - (y / vh)) * 100; // 0 at bottom, 100 at very top
}

function snapToBand(pct, directionDown) {
    // Direction rule: if swiping DOWN and endpoint below 50% -> close
    if (directionDown) {
        if(pct > 70) {
            setSheet(null);
        } else if(pct > 40) {
            setSheet('short');
        } else {
            modalInstance.hide();
            fenixIsOpen = false;
            fenixModalPurpose = null;
            return;
        }
    } else {
        if(pct > 75) {
            setSheet('tall');
        } else if(pct > 50) {
            setSheet(null);
        } else if(pct > 25) {
            setSheet('short');
        }
    }
}

// ------------------------------------------------------------
// Modal Content manipulation functions.
// ------------------------------------------------------------
export async function openFenixModal() {
    // Close the modal if it is already open.
    closeFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is closed before opening it.
    
    // Open it.
    modalInstance.show();
    fenixIsOpen = true;
}
// window.openFenixModal = openFenixModal;

export function closeFenixModal() {
    log('function: closeFenixModal');
    modalInstance.hide();
    fenixIsOpen = false;
    fenixModalPurpose = null;
}
// window.closeFenixModal = closeFenixModal;

/**
 * Set the content of the Fenix modal.
 * @param {string|null|true} title - The title of the modal. Null means no title. True means don't change it - for use when the modal is already open.
 * @param {string|jQuery|null} body - The body of the modal. Can be a string or a jQuery object or a template element or null.
 * @param {string|jQuery|null|true} footer - The footer of the modal. Can be a string or a jQuery object or null. True means don't change it - for use when the modal is already open.
 * @param {'xl'|'lg'|'md'|'sm'|'xs'|true|null} desktopSize - The size of the modal. Can be 'xl' (extra large), 'lg' (large), 'md' (medium), or 'sm' (small). Default (null) is 'lg'. True means don't change it - for use when the modal is already open.
 * @param {'tall'|'short'|'mini'|true|null} mobileHeight - Whether to set the mobile height of the modal. Default is null. Null means use the default height. True means don't change it - for use when the modal is already open.
 * @param {string|null|true} dataPurpose - A string to identify the purpose of the modal content. Used for CSS selectors and data attributes. True means don't change it.
 */
export function setFenixModalContent(title=null, body=null, footer=null, desktopSize=null, mobileHeight=null, dataPurpose=null, hideHeader=false) {
    log('setFenixModalContent', title, body, footer, desktopSize, mobileHeight, dataPurpose);

    // update the data purpose
    if(dataPurpose !== true) {
        if(dataPurpose) {
            $modal.attr('data-purpose', dataPurpose);
        } else {
            $modal.removeAttr('data-purpose');
        }
    }

    // update the desktop size of the modal
    if(desktopSize === null) {
        desktopSize = 'lg'; // default to large if not set
    }
    if(desktopSize !== true) {
        $modal.removeClass('fenix-xl fenix-lg fenix-md fenix-sm fenix-xs');
        if(desktopSize && ['xl', 'lg', 'md', 'sm', 'xs'].includes(desktopSize)) {
            $modal.addClass(`fenix-${desktopSize}`);
        }
    }

    // Set default mobileHeight
    if(mobileHeight !== true) {
        $modal.removeClass('tall short mini');
        if(mobileHeight && ['tall', 'short', 'mini'].includes(mobileHeight)) {
            $modal.addClass(mobileHeight);
        }
    }

    // Clean up old Swipers (from previous content)
    destroyFenixSwipers();
    // destroyFenixSimpleBar();

    // update the content
    if(title !== true) {
        $title.empty().append(title);
    }
    $body.empty();
    if(body) {
        $body.append(body);
    }
    if(footer !== true) {
        $footer.empty();
        if(footer) {
            $footer.append(footer);
            log('Fenix Modal footer', footer);
            log('New Footer code:', $footer.html());
        }
    }

    if(hideHeader === true) {
        // Hide header without disrupting the click to drag capability. (Can't just hide $header)
        $header.find('.offcanvas-title').addClass('d-none');
        // $header.find('button.btn-close').addClass('d-none'); // Keep the close button.
        $body.addClass('pt-0');
    } else {
        $header.find('.offcanvas-title').removeClass('d-none');
        $body.removeClass('pt-0');
    }

    // Initialize new Swipers (for new content)
    initFenixSwipers();

    // Init SimpleBar for new content
    // initFenixSimpleBar();

    return true; // content was updated
}

/**
 * Update the Fenix modal with the given action.
 * @param {string} action - The action to update the modal with.
 * @returns {null|boolean} Returns null if the modal was not updated, false if the action is unknown, otherwise returns true.
 */
// export async function updateFenixModal(action, value=null) {
//     log('updateFenixModal', action, value);

//     // Set Modal Configuration based on the action.
//     // Define openFirst flag based on the action: If set, the modal will be opened first with a spinner and then the content will be updated. Good for when the content is not ready immediately.
//     // openFirst - If true, the modal will be opened first with a spinner and then the content will be updated. Good for when the content is not ready immediately.
//     // Set defaults and then override with the action.
//     let openFirst = false;
//     let modalTitle = '';
//     let bodyTemplate = null;
//     let footerTemplate = 'defaultFooter';
//     let modalSize = 'lg';

//     if(action == 'singleStageShare') {
//         openFirst = false;
//         modalTitle = 'Share Stage';
//         bodyTemplate = 'singleStageShareModalTemplate';
//         modalSize = 'xl';
//         if(value) {
//             //Validate the stage id
//         } else {
//             log('updateFenixModal: Missing stage id');
//             return false;
//         }
//     } else if(action == 'singleStageShare2') {
//         openFirst = true;
//         modalTitle = 'Share Single Stage 2';
//         bodyTemplate = 'singleStageShare2';
//     } else {
//         log('updateFenixModal: Unknown action', action);
//         return false;
//     }

//     // Clean up old Swipers (from previous content)
//     destroyFenixSwipers();

//     if(openFirst) {
//         // Load animated bootstrap placeholder for loading.
//         setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), null, modalSize);
//         openFenixModal();
//         await nextFrame();
//         await delay(2000); //wait 2 seconds for testing.
//     }

//     // Get the body and footer templates
//     const modalBody = getTemplate(bodyTemplate);
//     const modalFooter = getTemplate(footerTemplate);

//     // Set the modal content
//     setFenixModalContent(modalTitle, modalBody, modalFooter, modalSize);

//     // If we didn't open first, open now (after content is ready)
//     if (!openFirst) {
//         openFenixModal()
//     };

//     // Initialize new Swipers (for new content)
//     initSwipersIn(modalEl);

//     return true; // content was updated
// }
// window.updateFenixModal = updateFenixModal;

export function destroyFenixSwipers() {
    destroySwipersIn(modalEl);
}
export function initFenixSwipers() {
    initSwipersIn(modalEl);
}

export function initFenixSimpleBar() {
    if (modalEl && !SimpleBar.instances.has(modalEl)) {
        log('initFenixSimpleBar');
        modalEl._simpleBar = new SimpleBar(modalEl);
    }
}

export function destroyFenixSimpleBar() {
    if (modalEl && modalEl._simpleBar) {
        log('destroyFenixSimpleBar');
        modalEl._simpleBar.unMount();
        modalEl._simpleBar = null;
    }
}


/**
 * Set the backdrop state of the Fenix modal.
 * @param {boolean} backdrop - The backdrop state to set. True means with backdrop, false means without backdrop.
 */
export async function setFenixBackdrop(backdrop=true) {
    // Check the backdrop state of the Fenix modal and re-init if needed.
    const backdropState = getFenixModalBackdropState();
    if(backdropState === backdrop) {
        // No change required, do nothing.
        return;
    } else{
        // Change required, re-init.
        log('setFenixBackdrop: Fenix modal backdrop state is changing, re-initing');
        await destroyFenixModal();
        initFenixModal(backdrop);
    }
}
